"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { cn } from "@repo/ui/utils";
import { ResourceCard } from "@/components/cards/resource-card";
import { CategoryPills } from "@/components/listing/category-pills";
import { LoadMoreButton } from "@/components/listing/load-more-button";
import { useListingState } from "@/components/listing/use-listing-state";
import type { ResourceListingProps } from "./resource-listing.types";
export function ResourceListing(t0) {
  const $ = _c(34);
  const {
    headline,
    initialItems,
    initialTotal,
    categories,
    pageSize,
    fetchMore,
    className
  } = t0;
  const t = useTranslations("directory");
  let t1;
  if ($[0] !== fetchMore || $[1] !== initialItems || $[2] !== initialTotal || $[3] !== pageSize) {
    t1 = {
      initialItems,
      initialTotal,
      pageSize,
      fetchMore
    };
    $[0] = fetchMore;
    $[1] = initialItems;
    $[2] = initialTotal;
    $[3] = pageSize;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    items,
    selectedCategoryId,
    isPending,
    hasMore,
    setSelectedCategoryId,
    loadMore
  } = useListingState(t1);
  let t2;
  if ($[5] !== className) {
    t2 = cn("py-16", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== headline) {
    t3 = <h2 className="typography-mobile-heading-h5 desktop:typography-desktop-heading-h6 text-text-primary">{headline}</h2>;
    $[7] = headline;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("viewAll");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== categories || $[12] !== selectedCategoryId || $[13] !== setSelectedCategoryId || $[14] !== t4) {
    t5 = <div className="pb-3"><CategoryPills categories={categories} selectedCategoryId={selectedCategoryId} onSelect={setSelectedCategoryId} allLabel={t4} size="sm" /></div>;
    $[11] = categories;
    $[12] = selectedCategoryId;
    $[13] = setSelectedCategoryId;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isPending || $[17] !== items || $[18] !== t) {
    t6 = items.length === 0 && !isPending ? <p className="typography-body-md-regular text-text-secondary">{t("noResults", {
        label: t("categories").toLowerCase()
      })}</p> : <ul className={cn("grid grid-cols-2 gap-x-4 gap-y-8", "tablet:grid-cols-2 tablet:gap-x-6", "desktop:grid-cols-4 desktop:gap-y-20", isPending && "opacity-60 transition-opacity")}>{items.map(_temp)}</ul>;
    $[16] = isPending;
    $[17] = items;
    $[18] = t;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== hasMore || $[21] !== isPending || $[22] !== loadMore) {
    t7 = hasMore && <LoadMoreButton onClick={loadMore} isPending={isPending} />;
    $[20] = hasMore;
    $[21] = isPending;
    $[22] = loadMore;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className="flex flex-col gap-8 desktop:gap-12">{t5}{t6}{t7}</div>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t3 || $[29] !== t8) {
    t9 = <div className="container screen-padding"><div className="flex flex-col gap-6 desktop:gap-5">{t3}{t8}</div></div>;
    $[28] = t3;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t2 || $[32] !== t9) {
    t10 = <section className={t2} data-testid="resource-listing">{t9}</section>;
    $[31] = t2;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
}
function _temp(item) {
  return <li key={item._id}><ResourceCard title={item.title ?? ""} href={item.externalUrl} logoLight={item.logoLight} description={item.description} /></li>;
}